import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiProjectsList, apiProjectsView } from 'Services/AdminService'

export const getData = createAsyncThunk('admin/projects/getData', async datas => {
    const { data } = await apiProjectsList(datas)
    return data
})

export const getView = createAsyncThunk('admin/projects/getView', async id => {
    if (!id) return viewData
    const { data } = await apiProjectsView(id)
    return data
})

const viewData = {
    collection_point_id: '',
    collector_id: [],
    name: '',
    contact_name: '',
    contact_phone: '',
    type: '0',
    address: '',
    longitude: '',
    latitude: '',
}

export const projectsSlice = createSlice({
    name: 'admin/projects',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData } = projectsSlice.actions

export default projectsSlice.reducer
